import
  React, {
  Component,
} from 'react';

import
  styled
from 'styled-components';

import {
  Colors,
  DataStore,
  FontFamilies,
  FontSizes,
  Image,
  MediaQueries,
  Theme,
  Logger,
  isValidProviderResult,
  updateThemeColor,
} from 'common';

import {
  Button,
  EventCard,
  OrganiserCard,
  Footer,
  H2,
  Text,
  Modal,
} from 'common/components';

import {
  WeTicketLogo
} from 'common/components/svg';

import {
  withCommon,
} from 'common/hocs';

import {
  EventProvider
} from 'providers';

const MainContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${Theme.HeroSection.Background};
  box-shadow: ${Theme.HeroSection.BoxShadow};
`;

const MainImage = styled.img`
  display: ${props => props.isMobile ? 'block' : 'none'};
  max-width: ${Theme.HeroSection.MaxWidth};
  background-color: ${Theme.HeroSection.Background};
  padding: ${Theme.HeroSection.Padding};
  width: 100%;

  @media only screen and ${MediaQueries.Sm} {
    display: ${props => props.isMobile ? 'none' : 'block'};
  }
`;

const BottomFadeContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30%;
  background-color: ${Colors.Black};
  background: linear-gradient(0deg, ${Colors.Black} 0%, ${Colors.Transparent} 100%);
  pointer-events: none;
`;

const Container = styled.div`
  ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  ${props => props.boxShadow && `box-shadow: ${props.boxShadow};`}
  ${props => props.flex && `flex: 1;`}
  position: relative;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
`;

const EventsContainer = styled.div`
  position: relative;
  display: grid;
  grid-gap: 22px;
  grid-template-columns: 1fr;
  padding: 0 0 40px 0;

  @media only screen and ${MediaQueries.Md} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 3vmin;
  }

  @media only screen and ${MediaQueries.Lg} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 3vmin;
  }
`;

const CalloutBanner = styled.img`
  width: 100%;
  max-width: 850px;
  margin: 25px auto 0 auto;

  @media only screen and ${MediaQueries.Md} {
    border-radius: 10px;
  }
`;

const FooterMobileSpace = styled.div`
  height: 15px;

  @media only screen and ${MediaQueries.Md} {
    display: none;
  }
`;

const SponsorImage = styled.img`
  display: none;

  @media only screen and ${MediaQueries.Md} {
    display: inline;
  }
`;

const SponsorImageMobile = styled.img`
  display: inline;

  @media only screen and ${MediaQueries.Md} {
    display: none;
  }
`;

const SliderContainer = styled.div`
  overflow: hidden;
  background: white;
  position: relative;
  width: 100%;
`;

const SlideTrack = styled.div`
  display: flex;
  height: 150px;
  padding: 10px 0;
  animation: scroll ${props => props.imageCount * 10}s linear infinite;

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-${props => props.imageWidth * props.imageCount}px);
    }
  }

  /*&:hover {
    animation-play-state: paused;
  }*/

  @media only screen and ${MediaQueries.Md} {
    height: 200px;
  }
`;

const SlideImage = styled.img`
  height: 100%;
  width: 200px;
  padding: 0 40px 0 0;
  object-fit: contain;
`;

const SellYourTicketsContainer = styled.div`
  background-color: ${Theme.Footer.CalloutBanner.Background};
  width: 100%;
  padding: 20px 0;
  box-shadow: ${Theme.Footer.CalloutBanner.BoxShadow};
  margin-top: ${props => props.addMargin ? '50px' : '20px'};
  color: ${Theme.Footer.CalloutBanner.Color};
`;

const SellYourTicketsRow = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  gap: 10px;

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
    text-align: left;
  }
`;

const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 48px 24px;
  z-index: 1;
  ${props => props.$showOverlay && `
    background:
      radial-gradient(ellipse at 50% 42%, rgba(8, 10, 12, 0.18) 0%, rgba(8, 10, 12, 0.42) 58%, rgba(8, 10, 12, 0.58) 100%),
      linear-gradient(180deg, rgba(8, 10, 12, 0.12) 0%, rgba(8, 10, 12, 0.38) 100%);
  `}
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 760px;
  min-width: 0;
`;

const HeroHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const heroTextShadow = '0 2px 28px rgba(0, 0, 0, 0.35)';

const HeroTitle = styled.h1`
  margin: 0;
  color: ${Colors.White};
  font-family: ${FontFamilies.ExtraBold};
  font-size: clamp(2.1rem, 5vw, 3.6rem);
  font-weight: normal;
  line-height: 1.2;
  letter-spacing: -0.03em;
  ${props => props.$showOverlay && `text-shadow: ${heroTextShadow};`}

  @media only screen and ${MediaQueries.Md} {
    line-height: 1.1;
    letter-spacing: -0.03em;
  }
`;

const HeroSubtitle = styled.p`
  display: none;
  margin: 0;
  color: ${Colors.White};
  font-family: ${FontFamilies.Bold};
  font-size: clamp(1.15rem, 2.6vw, 1.85rem);
  line-height: 1.25;
  letter-spacing: -0.02em;
  opacity: 0.94;
  ${props => props.$showOverlay && `text-shadow: ${heroTextShadow};`}

  @media only screen and ${MediaQueries.Md} {
    display: block;
  }
`;

const HeroSubSubtitle = styled.p`
  margin: 14px 0 0;
  color: ${Colors.White};
  font-family: ${FontFamilies.Bold};
  font-weight: normal;
  font-size: clamp(0.95rem, 1.7vw, 1.2rem);
  line-height: 1.5;
  max-width: 28em;
  opacity: 0.82;
  ${props => props.$showOverlay && `text-shadow: 0 1px 18px rgba(0, 0, 0, 0.35);`}
`;

const HeroActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
  margin-top: 18px;

  > div {
    box-sizing: border-box;
    height: 34px;
    padding: 0 16px;
    font-size: ${FontSizes.Smaller};
    letter-spacing: 0.06em;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  > div:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
  }

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: auto;
    gap: 14px;
    margin-top: 28px;

    > div {
      height: 48px;
      padding: 0 28px;
      font-size: ${FontSizes.Small};
      letter-spacing: 0.08em;
    }
  }
`;

const PoweredByContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  gap: 20px;

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

class homeUI extends Component {

  state = {
    coverImageDesktop: '',
    coverImageMobile: '',
    sponsorBannerDesktop: {},
    sponsorBannerMobile: {},
    sponsorSliderImages: [],
    calloutBanner: {},
    footerLogos: [],
    mainEvent: {},
    events: [],
    pastEvents: [],
    organiserCards: [],
    merchCards: [],
    heroConfig: {},
    widgetConfig: {},
    showTerms: false,
    showPrivacyPolicy: false,
    showContactForm: false,
    showFeaturedPastEvents: false,
    showingAllPastEvents: false,
    showAllPastEventsLoading: false,
  };

  onHeroButtonClick = (button) => {

    if (!button) {
      return;
    }

    if (button.scroll_to) {

      const section = document.getElementById(button.scroll_to);

      if (section) {
        const top = section.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top, behavior: 'smooth' });
      }

      return;
    }

    if (!button.href) {
      return;
    }

    if (button.external) {
      window.open(button.href, '_blank');
      return;
    }

    this.props.common.navigate(button.href);
  };

  onGetTicketsClick = (event) => {

    DataStore.set('homeScrollPosition', window.scrollY);
    DataStore.clear('verifyGuid');
    DataStore.clear('selectedTickets');
    this.props.common.navigate(`/event/details/${event.redirect_id || event.id}`);
  };

  onGetMerchClick = (eId, redirectUrl) => {

    DataStore.set('homeScrollPosition', window.scrollY);
    this.props.common.navigate(redirectUrl || `/event/merch/select?e_id=${eId}`);
  };

  onShowMorePastEvents = async () => {
    try {
      this.setState({ showAllPastEventsLoading: true });

      const pEvents = await EventProvider.getPastEvents(false); // Get all past events
      
      if (isValidProviderResult(pEvents)) {
        // Get the IDs of currently displayed events to avoid duplicates
        const currentEventIds = new Set();
        this.state.pastEvents.forEach(eventComponent => {
          const key = eventComponent.key;
          if (key && key.includes('past-event-')) {
            // Extract event ID from the key (e.g., 'past-event-123' -> '123')
            const eventId = key.replace('past-event-', '');
            currentEventIds.add(eventId);
          }
        });

        // Filter out events that are already displayed
        const newEvents = (pEvents.data || []).filter(event => 
          !currentEventIds.has(event.id.toString())
        );

        // Create components for the new events
        const newEventComponents = newEvents.map(event => {
          const soldOut = event.total_available_tickets <= 0;
          
          return (
            <EventCard
              key={`past-event-${event.id}`}
              image={event.cover_media_url}
              eventText={event.name}
              location={event.location_display}
              height={'250px'}
              width={'100%'}
              hideFavButton={true}
              month={event.displayMonth}
              day={event.displayDay}
              price={event.priceDisplay}
              pricePrefix={event.pricePrefix}
              time={event.displayTime}
              callout={event.callout
                ? event.callout
                : soldOut
                  ? 'Sold Out'
                  : event.total_available_tickets < 10
                    ? `Only ${event.total_available_tickets} left`
                    : ''
                }
                showDate={!event.is_multi_event}
                onClick={() => this.onGetTicketsClick(event)}
            />
          );
        });

        // Append new events to existing ones
        this.setState({
          pastEvents: [...this.state.pastEvents, ...newEventComponents],
          showingAllPastEvents: true
        });
      }
    } catch (e) {
      Logger.error('Home', 'onShowMorePastEvents', e);
      this.props.common.showToast('Unable to load more past events, please try again.');
    } finally {
      this.setState({ showAllPastEventsLoading: false });
    }
  };

  load = async () => {

    if (window.location.href.includes('etiquetteacademysa')) {
      
      window.location.href = `/etiquetteacademysa`;
      
      // Wait for 120 seconds before redirecting
      await new Promise(resolve => setTimeout(resolve, 120000));
      return;
    }

    // Custom implementation for Summer Festival
    if (window.location.href.includes('summerfestival')) {

      this.props.common.navigate(`/summerfestival`);
      return;
    }

    let siteConfigRet = await EventProvider.getEventSiteConfig();

    if (siteConfigRet.ok && siteConfigRet.data) {

      let subdomain = window.location.hostname.split('.')[0];

      if (subdomain === 'www') {
        subdomain = window.location.hostname.split('.')[1];
      }

      const siteConfig = siteConfigRet.data[subdomain] || siteConfigRet.data.default;

      if (siteConfig) {

        const merchCards = (siteConfig.merch_cards || []).map((m, index) => (
          <EventCard
            key={`m-card-${index}`}
            image={m.cover_media_url}
            eventText={m.title}
            location={m.sub_title}
            height={'250px'}
            width={'100%'}
            hideFavButton={true}
            price={m.price_text}
            pricePrefix={m.price_pre_text}
            showDate={false}
            onClick={() => this.onGetMerchClick(m.event_id, m.redirect_url)}
          />
        ));

        const footerLogoComponents = (siteConfig.footer_logos || []).map((logo, index) => (
          <Image
            key={`footerlogo-${index}`}
            src={logo.src}
            height={logo.height}
            width={logo.width}
            margin={'20px 0 20px 30px'}
            onClick={() => window.open(logo.redirect_url, '_blank')}
          />
        ));

        const sponsorSliderImages = (siteConfig.sponsor_banner?.slider_images || []).map((image, index) => (
          <SlideImage key={`sponsor-slider-image-${index}`} src={image} alt="Sponsor Slider Image" />
        ));

        if (siteConfig.theme_color && !this.props.common.isWidget) {
          updateThemeColor(siteConfig.theme_color);
        }

        const organiserCards = (siteConfig.organisers || []).map((organiser, index) => (
          <OrganiserCard
            key={`organiser-card-${index}`}
            image={organiser.cover_image}
            name={organiser.name}
            height={'250px'}
            width={'100%'}
            onClick={() => {
              window.location.href = organiser.link;
            }}
          />
        ));

        const heroButtons = (Array.isArray(siteConfig.hero_buttons) ? siteConfig.hero_buttons : [])
          .filter(button => button?.text)
          .slice(0, 2);

        if (!heroButtons.length && siteConfig.hero_button_text) {
          heroButtons.push({
            text: siteConfig.hero_button_text,
            href: 'https://features.weticket.co.za',
            external: true,
          });
        }

        this.setState({
          coverImageDesktop: siteConfig.splash_desktop,
          coverImageMobile: siteConfig.splash_mobile || siteConfig.splash_desktop,
          sponsorBannerDesktop: siteConfig.sponsor_banner_desktop,
          sponsorBannerMobile: siteConfig.sponsor_banner_mobile || siteConfig.sponsor_banner_desktop,
          calloutBanner: siteConfig.callout_banner || {},
          footerLogos: footerLogoComponents,
          sponsorSliderImages: sponsorSliderImages,
          merchCards: merchCards,
          organiserCards: organiserCards,
          heroConfig: {
            title: siteConfig.hero_title,
            subtitle: siteConfig.hero_subtitle,
            sub_subtitle: siteConfig.hero_sub_subtitle,
            buttons: heroButtons,
            overlay: !!siteConfig.overlay
          },
          widgetConfig: siteConfig.widget_config || {}
        });
      }

      if (siteConfig?.show_past_events) {

        EventProvider.getPastEvents(siteConfig.show_past_featured_events).then(pEvents => {

          if (isValidProviderResult(pEvents)) {

            this.setState({
              pastEvents: (pEvents.data || []).map(event => {
              
                const soldOut = event.total_available_tickets <= 0;
  
                return (
                  <EventCard
                    key={`past-event-${event.id}`}
                    image={event.cover_media_url}
                    eventText={event.name}
                    location={event.location_display}
                    height={'250px'}
                    width={'100%'}
                    hideFavButton={true}
                    month={event.displayMonth}
                    day={event.displayDay}
                    price={event.priceDisplay}
                    pricePrefix={event.pricePrefix}
                    time={event.displayTime}
                    callout={event.callout
                      ? event.callout
                      : soldOut
                        ? 'Sold Out'
                        : event.total_available_tickets < 10
                          ? `Only ${event.total_available_tickets} left`
                          : ''
                      }
                      showDate={!event.is_multi_event}
                      onClick={() => this.onGetTicketsClick(event)}
                  />
                );
              }),
              showFeaturedPastEvents: siteConfig.show_past_featured_events,
              showingAllPastEvents: false
            });
          }
        })
        .catch(e => {
          Logger.error('Home', 'load - past events', e);
        });
      }
    }

    let ret = await EventProvider.getPublicLiveEvents();

    if (!isValidProviderResult(ret)) {

      // TODO: Show toast
      Logger.error('Home', 'load - get public live events', ret?.message || 'Unknow error');
      return;
    }

    if (!Array.isArray(ret.data) || !ret.data.length) {

      // TODO: handle no events found to display
      return;
    }

    let eventComponents = [];

    for (const event of ret.data) {

      const isSoldOut = event.total_available_tickets <= 0 || event.available_venue_capacity <= 0;

      eventComponents.push(
        <EventCard
          key={event.id}
          image={event.cover_media_url}
          eventText={event.name}
          location={event.location_display}
          height={'250px'}
          width={'100%'}
          hideFavButton={true}
          month={event.displayMonth}
          day={event.displayDay}
          price={event.priceDisplay}
          pricePrefix={event.pricePrefix}
          time={event.displayTime}
          callout={event.callout
            ? event.callout
            : isSoldOut
              ? 'Sold Out'
              : event.total_available_tickets < 10
                ? `Only ${event.total_available_tickets} left`
                : ''
          }
          showDate={!event.is_multi_event}
          onClick={() => this.onGetTicketsClick(event)}
        />
      );
    }

    this.setState({
      events: eventComponents
    });

    setTimeout(() => {
      const scrollPosition = DataStore.get('homeScrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition, 10));
        DataStore.clear('homeScrollPosition')
      }
    }, 0);
  };

  componentDidMount = () => {

    homeUI.timestamp = new Date().getTime();

    this.props.common.showLoading();

    DataStore.clear('verifyGuid');
    DataStore.clear('selectedTickets');
    DataStore.clear('selectedEvent');

    this.load()
      .catch(e => {
        
        Logger.error('Home', 'load', e);

        this.props.common.showToast('Oh no, we weren\'t able to load event details, please try again.');

        this.props.common.hideLoading();
      })
      .finally(() => this.props.common.hideLoading());
  };

  render () {

    return (

      <>

        { (!this.props.common.isWidget || this.state.widgetConfig.show_splash_image) &&
          <MainContainer>

            <MainImage
              isMobile={false}
              src={this.state.coverImageDesktop || this.state.mainEvent.featured_media_url || this.state.mainEvent.cover_media_url}
            />

            <MainImage
              isMobile={true}
              src={this.state.coverImageMobile || this.state.mainEvent.featured_media_url || this.state.mainEvent.cover_media_url}
            />

            { this.state.heroConfig?.title &&
              <HeroContainer $showOverlay={this.state.heroConfig.overlay}>
                <HeroContent>
                  <HeroHeading>
                    <HeroTitle $showOverlay={this.state.heroConfig.overlay}>{this.state.heroConfig.title}</HeroTitle>
                    { this.state.heroConfig.subtitle &&
                      <HeroSubtitle $showOverlay={this.state.heroConfig.overlay}>{this.state.heroConfig.subtitle}</HeroSubtitle>
                    }
                  </HeroHeading>
                  { this.state.heroConfig.sub_subtitle &&
                    <HeroSubSubtitle $showOverlay={this.state.heroConfig.overlay}>{this.state.heroConfig.sub_subtitle}</HeroSubSubtitle>
                  }
                  { this.state.heroConfig.buttons?.length > 0 &&
                    <HeroActions>
                      {this.state.heroConfig.buttons.map((button, index) => {

                        const isOutline = button.variant === 'outline';

                        return (
                          <Button
                            key={`hero-button-${index}`}
                            onClick={() => this.onHeroButtonClick(button)}
                            backgroundColor={isOutline ? Colors.Transparent : Colors.White}
                            textColor={isOutline ? Colors.White : Colors.Black}
                            fontFamily={FontFamilies.Bold}
                            border={isOutline ? '2px solid rgba(255, 255, 255, 0.92)' : 'none'}
                            borderRadius={'50px'}
                            width={'auto'}
                            text={button.text}
                          />
                        );
                      })}
                    </HeroActions>
                  }
                </HeroContent>
              </HeroContainer>
            }

            {false && <BottomFadeContainer/>}

          </MainContainer>
        }

        { !this.props.common.isWidget && this.state.calloutBanner?.src &&
        
          <CalloutBanner
            alt={'Callout Banner'}
            src={this.state.calloutBanner.src}
          />
        }

        <Container flex={true} id={'upcoming-events'} style={{ scrollMarginTop: '90px' }}>

          {!this.props.common.isWidget && <H2 margin={'45px 0 30px 0'}>Upcoming Events</H2>}

          {this.props.common.isWidget &&

            <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px 0', borderBottom: `1px solid ${Theme.Divider.Color}` }}>
              <H2 margin={'0'} style={{ fontSize: '20px' }}>Upcoming Events</H2>
              <Button 
                onClick={() => {
                  if (DataStore.get('LOGGED_IN_EMAIL') && DataStore.get('ACCESS_TOKEN')) {
                    this.props.common.navigate('/profile/view-my-tickets');
                  } else {
                    this.props.common.navigate('/identity/otp-login');
                  }
                }} 
                backgroundColor={Colors.Primary} 
                textColor={Colors.White} 
                fontFamily={FontFamilies.Bold} 
                border={'none'} 
                width={'125px'} 
                text={'MY TICKETS'}
              />
            </div>
            <div style={{ height: '35px' }} />
            </>
          }
          
            { this.state.events?.length > 0
            
              ? <EventsContainer>

                  {this.state.events}

                </EventsContainer>

              : <Text padding={'0 0 140px 0'}>There are no upcoming events scheduled at the moment.</Text>
            }

        </Container>

        { this.state.organiserCards?.length > 0 &&

          <Container>

            <H2 margin={'0 0 0.8em 0'}>Organisers</H2>
            
            <EventsContainer>

              {this.state.organiserCards}

            </EventsContainer>

          </Container>
        }

        { this.state.pastEvents?.length > 0 &&

          <Container>

            <H2 margin={'0 0 0.8em 0'}>Past Events</H2>
            
              <EventsContainer>

                {this.state.pastEvents}

              </EventsContainer>

              { this.state.showFeaturedPastEvents && !this.state.showingAllPastEvents &&
                <div style={{ display: 'flex', justifyContent: 'center', padding: '0 0 20px 0' }}>
                  <Button
                    onClick={this.onShowMorePastEvents}
                    backgroundColor={Colors.Transparent}
                    textColor={Colors.PrimaryOne}
                    fontFamily={FontFamilies.Bold}
                    border={`2px solid ${Colors.PrimaryOne}`}
                    width={'200px'}
                    showLoading={this.state.showAllPastEventsLoading}
                    text={'SEE ALL PAST EVENTS'}
                  />
                </div>
              }

          </Container>
        }

        { this.state.merchCards.length > 0 &&
        
          <Container>

            <H2 margin={'0 0 0.8em 0'} style={{ fontSize: this.props.common.isWidget ? '20px' : undefined }}>Products</H2>
            
              <EventsContainer>

                {this.state.merchCards}

              </EventsContainer>

          </Container>
        }

        <div style={{ backgroundColor: Theme.SponsorBanner.BackgroundColor, width: '100%' }}>

          <Container>
            { this.state.sponsorBannerDesktop?.src &&
              <SponsorImage
                alt={'sponsors'}
                style={{
                  width: this.state.sponsorBannerDesktop.width || '100%',
                  height: this.state.sponsorBannerDesktop.height || 'auto'
                }}
                src={this.state.sponsorBannerDesktop.src + '?t=' + + homeUI.timestamp} />
            }
            { this.state.sponsorBannerMobile?.src &&
              <>
                <FooterMobileSpace/>
                <SponsorImageMobile
                  alt={'sponsort'}
                  style={{
                    width: this.state.sponsorBannerMobile.width || '100%',
                    height: this.state.sponsorBannerMobile.height || 'auto'
                  }}
                  src={this.state.sponsorBannerMobile.src + '?t=' + + homeUI.timestamp}
                />
              </>
            }

            { this.state.sponsorSliderImages.length > 0 &&
              <SliderContainer>
                <SlideTrack imageCount={this.state.sponsorSliderImages.length} imageWidth={200}>
                  {this.state.sponsorSliderImages}
                  {this.state.sponsorSliderImages}
                </SlideTrack>
              </SliderContainer>
            }

          </Container>

        </div>

        { this.props.common.isWidget &&
          <Container>
            <div style={{ borderBottom: `1px solid ${Theme.Divider.Color}` }} />
            <PoweredByContainer>
              <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
                <Text fontSize={FontSizes.Small}>Powered by</Text>
                <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => window.open('https://weticket.co.za', '_blank')}>
                  <WeTicketLogo
                    height={38} 
                    width={175}
                  />
                </div>
              </div>
              <Button
                backgroundColor={Colors.Transparent}
                border={`2px solid ${Theme.Text.Color}`}
                textColor={Theme.EventIdentity.ButtonTextColor}
                fontSize={FontSizes.Smaller}
                fontFamily={FontFamilies.Bold}
                width={'185px'}
                text={'SELL ON WETICKET'}
                onClick={() => window.open('https://features.weticket.co.za', '_blank')}
              />
            </PoweredByContainer>
          </Container>
        }

        { !this.props.common.isWidget &&

          <SellYourTicketsContainer
            addMargin={this.state.sponsorBannerDesktop?.src || this.state.sponsorSliderImages.length > 0}>

            <SellYourTicketsRow>

              <Text fontSize={FontSizes.Regular} color={Theme.Footer.CalloutBanner.Color}>
                Hosting an event? Sell your tickets on WeTicket.
              </Text>

              <Button
                backgroundColor={Theme.Footer.CalloutBanner.Button.Background}
                textColor={Theme.Footer.CalloutBanner.Button.TextColor}
                fontFamily={FontFamilies.Bold}
                border={'none'}
                width={'185px'}
                text={'SELL ON WETICKET'}
                onClick={() => this.setState({showContactForm: true})}
              />  

            </SellYourTicketsRow>

          </SellYourTicketsContainer>
        }

        { !this.props.common.isWidget &&
          <div style={{ backgroundColor: Theme.Footer.BackgroundColor, width: '100%' }}>

            <Container>

              <Footer/>

            </Container>
          </div>
        }

        <Modal show={this.state.showContactForm} onClose={() => this.setState({showContactForm: false})}>
          <div style={{width: '800px', height: '70vh', maxWidth: '85vw'}}>
            <iframe 
              title={'Contact Us'} 
              src={'https://features.weticket.co.za/contactUs/contact.html?v=' + window.policyTimestamp} 
              width={'100%'} 
              height={'100%'}
              style={{backgroundColor: 'white', border: 'none'}}
            />
          </div>
        </Modal>
      </>
    );
  }
}

export const Home = withCommon(homeUI, {
  applyMaxWidth: false,
  transitionHeader: true,
  contentBackgroundColor: Theme.Home.Background,
  showHeaderYourTickets: true,
  scrollToTop: false,
});